import {lazy} from 'react'

export const ActivityFeedHandler = lazy(() => import('./../../../components/activity-feed'))

export const AssignmentsHandler = lazy(() => import('./../../../components/assignments'))

export const DashboardHandler = lazy(() => import('./../../../components/dashboard/handler'))

export const MobileReminderHandler = lazy(() => import('./../../../../pages/mobile-reminder'))

export const PricingHandler = lazy(() => import('./../../../../pages/pricing/components/'))

export const CheckoutHandler = lazy(() => import('./../../../../pages/checkout/components/'))

export const ReferralProgramHandler = lazy(
  () => import('./../../../../pages/referral-program/components/')
)

export const SettingsHandler = lazy(() => import('./../../../../pages/settings/components/'))

export const StudentGoalsHandler = lazy(() => import('./../../../../pages/student-goals'))

export const TeacherOnboardingHandler = lazy(
  () => import('./../../../components/teacher-onboarding')
)

export const ParentWelcomeHandler = lazy(() => import('./../../../components/parent-welcome'))

export const ReportsOverviewHandler = lazy(() => import('./../../../../pages/reports-overview'))
